'use strict';

function InterlineFaresAdjustmentCSVService(gridExportCSVService, restangular) {
  var fileUploadApi = restangular.one('external').all('partnerAdjustments').one('csv');

  /*
  Contains the Map of Key - Title for the CSV Header, values
   */
  var columnsHeaderMapToExport = {
    partnerSegment: 'Partner Segment',
    partnerAirline: 'Partner Carrier',
    trueOD: 'True OD',
    classNames: 'Classes',
    adjustmentType: 'Adjustment Type',
    fareAdjustment: 'Fare Adjustment'
  };
  function exportToCSV(rows) {
    return gridExportCSVService.exportToCSV(rows, columnsHeaderMapToExport, 'InterlineFaresAdjustments.csv');
  }
  function importCSV(file) {
    var formData = new FormData();
    formData.append('file', file);
    return fileUploadApi.customPOST(formData, '', undefined, {
      'Content-Type': undefined
    });
  }
  return {
    exportToCSV: exportToCSV,
    importCSV: importCSV
  };
}
InterlineFaresAdjustmentCSVService.$inject = ['GridExportCSVService', 'Restangular'];
module.exports = InterlineFaresAdjustmentCSVService;